import React from 'react';

export default class Page8 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToGetTheMostOutOfYourself');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div onClick={this._savePageStatus('HowToMotivateOthers')}
                                                        className="link_color task button-link-redirect">How to motivate others</div>
                                                    </li>
                                                    <li><div onClick={this._savePageStatus('HowToBeAssertive')}
                                                        className="link_color task button-link-redirect">How to be assertive</div></li>
                                                    <li><div onClick={this._savePageStatus('HowToGiveFeedback')}
                                                        className="link_color task button-link-redirect">How to give feedback</div>
                                                    </li>
                                                    <li><div onClick={this._savePageStatus('HowToSupportAndChallengeInTandem')}
                                                        className="link_color task button-link-redirect">How to support and challenge
                                                        in tandem</div></li>
                                                    <li><div onClick={this._savePageStatus('HowToDeliverEveryTime')}
                                                        className="link_color task button-link-redirect">How to deliver every
                                                        time.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Robertson, I. (2003).
                                                    <span className="subtiltereg"> The Mind's Eye: An Essential Guide to Boosting your Mental Power.</span> London:
                                                    Bantam.</p></li>
                                                <li><p className="further_info_content"> Rogers, C. (1967)
                                                    <span className="subtiltereg">   On Becoming a Person: A Therapist's View of Psychotherapy.  </span> London:
                                                    Constable.</p></li>
                                                <li><p className="further_info_content"> Hoffmann,
                                                    B. &amp; Spatariu, A. (2008). <span className="subtiltereg"> The influence of self-efficacy and metacognitive prompting on math
problem-solving efficiency Contemporary Educational Psychology, </span> 33 (4), 875-893.</p></li>
                                                <li><p className="further_info_content"> Criteria for signature
                                                    strengths taken from Peterson, C. &amp; Seligman, M. (2004).
                                                    <span className="subtiltereg"> Character strengths and
virtues: A handbook and classification. </span> Washington, DC: American Psychological Association.</p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
        ;
    }
}